import Image from 'next/legacy/image';
import React from 'react';
import { BodyRegular, H1 } from '@components/atoms/typography';
import Button from '@components/atoms/button';

const FPLError = () => {
  return (
    <div className="flex flex-col items-center py-10 px-5 max-w-[700px] mx-auto">
      <Image
        src="/images/fpl-logo-large.svg"
        height={100}
        width={500}
        alt="Page error image"
        className="rounded-lg"
      />
      <H1 className="text-center mt-6 mb-2">FPL connection error</H1>
      <BodyRegular className="text-center mt-1">
        It seems that FPL App is having connection issues, please try again
        shortly.
      </BodyRegular>
      <Button href="/" isLink variant="primary" className="mt-5">
        Return to home
      </Button>
    </div>
  );
};

export default FPLError;
